<template>
  <div :data-test="`${$route.name}Page`" class="c-helpPage">
    <div class="l-container">
      <div class="l-container--inner c-faqLink">
        <f-button
          :to="{ name: 'other-questions' }"
          :is-full-width="true"
          @click.native="handleOtherQuestionsLinkClick"
        >
          {{ content.faq_section_link_text }}
        </f-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FButton from '@justeat/f-button'

export default {
  name: 'HelpPage',
  components: {
    FButton
  },
  computed: {
    ...mapGetters(['content']),
    ...mapGetters('snowplow', ['cxFeatureContext', 'cxOrderContext'])
  },
  methods: {
    handleOtherQuestionsLinkClick: function handleOtherQuestionsLinkClick() {
      const context = [this.cxFeatureContext]
      if (this.cxOrderContext.data.id) { context.push(this.cxOrderContext) }
      this.$trackSelfDescEvent('otherQuestions_select', context)
    }
  }
}
</script>
